var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaHorizontalSidenav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Flechas/Derecha 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8837 16.5303C15.1766 16.8232 15.6515 16.8232 15.9444 16.5303L19.2373 13.2374C19.9207 12.554 19.9207 11.446 19.2373 10.7626L15.9444 7.46967C15.6515 7.17678 15.1766 7.17678 14.8837 7.46967C14.5908 7.76256 14.5908 8.23744 14.8837 8.53033L17.6034 11.25L4.41406 11.25C3.99985 11.25 3.66406 11.5858 3.66406 12C3.66406 12.4142 3.99985 12.75 4.41406 12.75L17.6034 12.75L14.8837 15.4697C14.5908 15.7626 14.5908 16.2374 14.8837 16.5303Z",
    fill: "#72A0E9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaHorizontalSidenav);
export default __webpack_public_path__ + "static/media/FlechaHorizontalSIDENAV.45ce01cee268d60a3f9f9a86e95d1073.svg";
export { ForwardRef as ReactComponent };